import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import DefaultInput from 'components/input/DefaultInput';
import { ILocalCurrencyProps } from 'utils/types/currencyTypes';
import { useTranslation } from 'react-i18next';

/**
 * * 플랫폼 - 재화 - 입력 & 수정 다국어 폼
 * * 오토메 작품 관리 - 인앱상품 - 드레스 - 입력 & 수정 다국어 폼
 */

interface IProps {
  langList: ILocalCurrencyProps[];
  onChange?: (e) => void;
}

const CurrencyLocalizingInput = ({ langList, onChange }: IProps) => {
  const { t } = useTranslation();
  return (
    <LocalizingForm>
      <h1>{t('currencyMasterID.formOne.goodName')}</h1>
      {langList?.map((v, i) => {
        return (
          <div className='section_input' key={i}>
            <DefaultInput
              name='currencyName'
              id={`${v.code}`}
              value={v.currencyName}
              onChange={onChange}
              codeName={t(`dbLngList.${i}.code_name`)}
              maxLength={30}
              top='true'
              localizing
              style={{ marginLeft: '0.5rem' }}
            />
          </div>
        );
      })}
    </LocalizingForm>
  );
};

export default CurrencyLocalizingInput;
const LocalizingForm = styled.form`
  > h1 {
    font-weight: 600;
    color: ${theme.colors.blue_7};
    font-size: ${theme.fontSizes.md};
    margin-left: 1rem;
    margin-bottom: 1rem;
  }
  .section_input {
    margin-bottom: 2rem;
  }
`;
